import React, { useEffect, Suspense, lazy } from "react";

import AdminPrivateRoutes from "../../AdminPrivateRoutes";
import SecureAdmin from "../../SecureAdmin";

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

//import Dashboard from "../../components/admin/Dashboard";
import Users from "../../components/admin/Users";
import Cat from "../../components/admin/Cat";
import Pag from "../../components/admin/Pag";

import Faq from "../../components/admin/Faq";
import Pos from "../../components/admin/Pos";
import MSlide from "../../components/admin/MSlide";
import HSlide from "../../components/admin/HSlide";
import Gal from "../../components/admin/Gal";

// import ComposeMail from "../../components/admin/ComposeMail";
import Inbox from "../../components/admin/Inbox";

import Page404 from "../../components/admin/Page404";

/* Added Components */
import Camera from "../../components/admin/childComponents/appComponents/Camera";
import Crop from "../../components/admin/childComponents/appComponents/Crop";
import GPS from "../../components/admin/childComponents/appComponents/GPS";
import QrCodes from "../../components/admin/childComponents/appComponents/QrCodes";
//import Pdf from "../../components/admin/childComponents/appComponents/Pdf";
import PrintDoc from "../../components/admin/childComponents/appComponents/PrintDoc";
//import QrScanner from "../../components/admin/childComponents/appComponents/QrScanner";

/*                                */
/* This is the webpage header CSS */
/*                                */

// Vendor CSS
import "../../assets/vendors/bootstrap/dist/css/bootstrap.min.css";
import "../../assets/vendors/font-awesome/css/font-awesome.min.css";
import "../../assets/vendors/themify-icons/css/themify-icons.css";
import "../../assets/vendors/jvectormap/jquery-jvectormap-2.0.3.css";
import "../../assets/css/pages/auth-light.css";



// Custom CSS
import "../../assets/css/main.css";
/* blue, green, purple, orange, pink, white, blue-light, green-light, purple-light, orange-light, pink-light */
/*     Change the themplate color */
import "../../assets/css/themes/green.css";
import "../../assets/css/custom.css";

/*                                    */
/* End This is the webpage header CSS */
/*                                    */
const Dashboard = React.lazy(() =>
  import("../../components/admin/Dashboard")
);
const QrScanner = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/QrScanner")
);
const Pdf = React.lazy(() =>
  import("../../components/admin/childComponents/appComponents/Pdf")
);
const MasterPagpage = (props) => {

  /*                                */
  /* This is the webpage header JS  */
  /*                                */

  useEffect(() => {

    // Dynamically load scripts
    const loadScript = (src) => {
      return new Promise((resolve) => {
        // Prevent duplicate loading
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = true;

        script.onload = () => resolve();

        document.body.appendChild(script);
      });
    };

    const loadScripts = async () => {
      // Load sequentially
      await loadScript("/assets/vendors/jquery/dist/jquery.min.js");

      await loadScript("/assets/vendors/popper.js/dist/umd/popper.min.js");

      await loadScript("/assets/vendors/bootstrap/dist/js/bootstrap.min.js");

      await loadScript("/assets/vendors/metisMenu/dist/metisMenu.min.js");

      await loadScript("/assets/vendors/jquery-slimscroll/jquery.slimscroll.min.js");
      await loadScript("/assets/vendors/chart.js/dist/Chart.min.js");
      await loadScript("/assets/vendors/jvectormap/jquery-jvectormap-2.0.3.min.js");
      await loadScript("/assets/vendors/jvectormap/jquery-jvectormap-world-mill-en.js");
      await loadScript("/assets/vendors/jvectormap/jquery-jvectormap-us-aea-en.js");
      await loadScript("/assets/js/app.min.js");

    };

    loadScripts();
  }, []);

  /*                                    */
  /* End This is the webpage header JS  */
  /*                                    */

  let tagName;

  switch (props.name) {
    case "Dashboard":
      tagName = <Suspense fallback={<div>Loading...</div>}><Dashboard /></Suspense>;
      break;
    case "Users":
      tagName = <Users />;
      break;
    case "Cat":
      tagName = <Cat />;
      break;
    case "Pag":
      tagName = <Pag />;
      break;

    case "Faq":
      tagName = <Faq />;
      break;
    case "Pos":
      tagName = <Pos />;
      break;
    case "MSlide":
      tagName = <MSlide />;
      break;
    case "HSlide":
      tagName = <HSlide />;
      break;
    case "Gal":
      tagName = <Gal />;
      break;
    case "Inbox":
      tagName = <Inbox />;
      break;

    case "Page404":
      tagName = <Page404 />;
      break;

    /* Added Components */
    case "GPS":
      tagName = <GPS />;
      break;
    case "Crop":
      tagName = <Crop />;
      break;
    case "PrintDoc":
      tagName = <PrintDoc />;
      break;
    case "Pdf":
      tagName = <Suspense fallback={<div>Loading...</div>}><Pdf /></Suspense>;
      break;
    case "QrCodes":
      tagName = <QrCodes />;
      break;
    case "QrScanner":
      tagName = <Suspense fallback={<div>Loading...</div>}><QrScanner /></Suspense>;
      break;
    case "Camera":
      tagName = <Camera />;
      break;

    default:
      tagName = <Dashboard />;
  }

  return (
    <>
      <AdminPrivateRoutes />
      <SecureAdmin />
      <div id="page-wrapper">
        <Navbar />
        <Sidebar />
        <div className="content-wrapper bg-white">
          <div className="page-content fade-in-up">{tagName}</div>
          <Footer />
        </div>
      </div>
    </>
  );
};
export default MasterPagpage;
